'use strict';
import { ContentTaskType } from '../../kb/tasks/content-task-type.enum';
import { WebNotificationType } from './web-notification-type.enum';
import { UserBuilder } from '../users/user-builder';
var WebNotificationBuilder = /** @class */ (function () {
    function WebNotificationBuilder(webNotification) {
        var defaultWebNotification = {
            id: 'b0bb0b0b-b0b0-b0b0-b0b0-b0bb0bb0bb0b',
            creationDate: Date.now() - 3600,
            createdByUser: new UserBuilder().build(),
            type: WebNotificationType.ANNOUNCEMENT,
            info: {
                recipientGroupIds: [],
                recipientQueueIds: [],
                userFullName: '',
                announcementSubject: '',
                announcementContent: '',
                articleId: '',
                articleTitle: '',
                ticketId: '',
                ticketSubject: '',
                noteContent: '',
                replyContent: '',
                taskType: ContentTaskType.WRITE
            },
            read: true,
            urgent: true
        };
        this.webNotification = webNotification || defaultWebNotification;
    }
    WebNotificationBuilder.prototype.withId = function (id) {
        this.webNotification.id = id;
        return this;
    };
    WebNotificationBuilder.prototype.withCreationDate = function (creationDate) {
        this.webNotification.creationDate = creationDate;
        return this;
    };
    WebNotificationBuilder.prototype.withCreatedByUser = function (user) {
        this.webNotification.createdByUser = user;
        return this;
    };
    WebNotificationBuilder.prototype.withType = function (type) {
        this.webNotification.type = type;
        return this;
    };
    WebNotificationBuilder.prototype.withInfo = function (info) {
        this.webNotification.info = info;
        return this;
    };
    WebNotificationBuilder.prototype.withRead = function (read) {
        this.webNotification.read = read;
        return this;
    };
    WebNotificationBuilder.prototype.withUrgent = function (urgent) {
        this.webNotification.urgent = urgent;
        return this;
    };
    WebNotificationBuilder.prototype.build = function () {
        return this.webNotification;
    };
    return WebNotificationBuilder;
}());
export { WebNotificationBuilder };
//# sourceMappingURL=web-notification.builder.js.map